<template>
  <v-list class="text-left" three-line>
    <v-list-item v-for="(degree, index) in items" :key="index">
      <v-list-item-icon>
        <v-icon>mdi-certificate</v-icon>
      </v-list-item-icon>

      <v-list-item-content>
        <v-list-item-title>{{ degree.name }}</v-list-item-title>

        <v-list-item-subtitle>
          <span class="text--primary">{{ degree.date | formatDate }}</span>
          — {{ degree.establishment }}
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <span v-if="degree.file" class="font-italic">Copie : {{ degree.file.name }}</span>
          <span v-else class="font-italic">Copie non annexée</span>
        </v-list-item-subtitle>

        <v-list-item-subtitle>
          <v-chip
            small
            color="primary"
            class="mt-1 mr-1"
            v-if="degree.mfp"
          >
            MFP
          </v-chip>

          <v-chip
            small
            color="secondary"
            class="mt-1 mr-1"
            v-if="degree.isForeign"
          >
            Etranger
          </v-chip>

          <v-chip
            small
            color="accent"
            class="mt-1 mr-1"
            v-if="degree.hasEquivalence"
          >
            Equivalence
          </v-chip>
        </v-list-item-subtitle>
      </v-list-item-content>

      <v-list-item-action v-if="showActions">
        <v-btn @click="$emit('remove-degree', degree)" icon>
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </v-list-item-action>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: 'DegreeList',

  props: {
    items: Array,
    showActions: Boolean,
  },
};
</script>
